function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_18",
  "data-name": "Trac\\xE9 18",
  d: "M223.569,154.7a1.171,1.171,0,0,0-1.171,1.171v22.131a1.171,1.171,0,1,0,2.342,0V155.874A1.171,1.171,0,0,0,223.569,154.7Zm0,0",
  transform: "translate(-205.874 -147.808)",
  fill: "#ff7272"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_19",
  "data-name": "Trac\\xE9 19",
  d: "M105.569,154.7a1.171,1.171,0,0,0-1.171,1.171v22.131a1.171,1.171,0,1,0,2.342,0V155.874A1.171,1.171,0,0,0,105.569,154.7Zm0,0",
  transform: "translate(-96.641 -147.808)",
  fill: "#ff7272"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_20",
  "data-name": "Trac\\xE9 20",
  d: "M2.177,9.757V28.671A4.235,4.235,0,0,0,3.3,31.593a3.78,3.78,0,0,0,2.743,1.186H20.571a3.78,3.78,0,0,0,2.743-1.186,4.235,4.235,0,0,0,1.126-2.921V9.757a2.933,2.933,0,0,0-.752-5.767h-3.93v-.96A3.015,3.015,0,0,0,16.717,0H9.9A3.015,3.015,0,0,0,6.86,3.031v.96H2.929a2.933,2.933,0,0,0-.752,5.767ZM20.571,31.243H6.046a2.431,2.431,0,0,1-2.334-2.572V9.825H22.9V28.671a2.431,2.431,0,0,1-2.334,2.572ZM8.4,3.031a1.479,1.479,0,0,1,1.5-1.5h6.817a1.479,1.479,0,0,1,1.5,1.5v.96H8.4ZM2.929,5.526H23.687a1.382,1.382,0,0,1,0,2.764H2.929a1.382,1.382,0,0,1,0-2.764Zm0,0",
  transform: "translate(0.003 0.002)",
  fill: "#ff7272"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_21",
  "data-name": "Trac\\xE9 21",
  d: "M164.569,154.7a1.171,1.171,0,0,0-1.171,1.171v22.131a1.171,1.171,0,0,0,2.342,0V155.874A1.171,1.171,0,0,0,164.569,154.7Zm0,0",
  transform: "translate(-151.257 -147.808)",
  fill: "#ff7272"
});

var SvgIcTrash = function SvgIcTrash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "delete",
    width: 26.623,
    height: 32.78,
    viewBox: "0 0 26.623 32.78",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_trash.d84363dd.svg";
export { ForwardRef as ReactComponent };